/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Analyze_Allocations_IntroInputs */

const en_admin_analyze_allocations_intro = /** @type {(inputs: Admin_Analyze_Allocations_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Occupancy is the percentage of days in the selected month that a resource was allocated.`)
};

const de_admin_analyze_allocations_intro = /** @type {(inputs: Admin_Analyze_Allocations_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Auslastung ist der Prozentsatz der Tage im ausgewählten Monat, an denen eine Ressource zugewiesen war.`)
};

const es_admin_analyze_allocations_intro = /** @type {(inputs: Admin_Analyze_Allocations_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La ocupación es el porcentaje de días del mes seleccionado en que un recurso estuvo asignado.`)
};

const fr_admin_analyze_allocations_intro = /** @type {(inputs: Admin_Analyze_Allocations_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le taux d'occupation est le pourcentage de jours dans le mois sélectionné pendant lesquels une ressource était attribuée.`)
};

/** @type {(inputs: Admin_Analyze_Allocations_IntroInputs) => LocalizedString} */
const it_admin_analyze_allocations_intro = en_admin_analyze_allocations_intro;

/** @type {(inputs: Admin_Analyze_Allocations_IntroInputs) => LocalizedString} */
const pt_br2_admin_analyze_allocations_intro = en_admin_analyze_allocations_intro;

/** @type {(inputs: Admin_Analyze_Allocations_IntroInputs) => LocalizedString} */
const pl_admin_analyze_allocations_intro = en_admin_analyze_allocations_intro;

/** @type {(inputs: Admin_Analyze_Allocations_IntroInputs) => LocalizedString} */
const hu_admin_analyze_allocations_intro = en_admin_analyze_allocations_intro;

/** @type {(inputs: Admin_Analyze_Allocations_IntroInputs) => LocalizedString} */
const ro_admin_analyze_allocations_intro = en_admin_analyze_allocations_intro;

/**
* | output |
* | --- |
* | "Occupancy is the percentage of days in the selected month that a resource was allocated." |
*
* @param {Admin_Analyze_Allocations_IntroInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_analyze_allocations_intro = /** @type {((inputs?: Admin_Analyze_Allocations_IntroInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Analyze_Allocations_IntroInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_analyze_allocations_intro(inputs)
	if (locale === "de") return de_admin_analyze_allocations_intro(inputs)
	if (locale === "es") return es_admin_analyze_allocations_intro(inputs)
	if (locale === "fr") return fr_admin_analyze_allocations_intro(inputs)
	if (locale === "it") return it_admin_analyze_allocations_intro(inputs)
	if (locale === "pt-BR") return pt_br2_admin_analyze_allocations_intro(inputs)
	if (locale === "pl") return pl_admin_analyze_allocations_intro(inputs)
	if (locale === "hu") return hu_admin_analyze_allocations_intro(inputs)
	return ro_admin_analyze_allocations_intro(inputs)
});
export { admin_analyze_allocations_intro as "admin.analyze.allocations.intro" }